import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useTranslation } from 'react-i18next';

import { BaseMessage } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/BaseMessage';
import { BaseText } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/BaseText';

import type { FC } from 'react';

export const BotTyping: FC = () => {
  const { t } = useTranslation();

  return (
    <BaseMessage avatarContent={<SupportAgentIcon />}>
      <BaseText sx={{ color: 'action.disabled' }}>
        {t('GSP.pages.parentHelper.chat.body.botTypingMessage')}
      </BaseText>
    </BaseMessage>
  );
};
